import React from "react";
import { formatAppDate } from "../../helpers/date-formatter";
import ArchiveIcon from "../../assets/ArchiveIcon";
import EditIcon from "../../assets/EditIcon";
import DeleteIcon from "../../assets/DeleteIcon";
import ActivateIcon from "../../assets/ActivateIcon";
import DataTable from "../table/DataTable";
import { MediaCell } from "../table/DataTableCell";
import StatusBadge from "../table/StatusBadge";
import ActionGroup, { ActionButton } from "../table/ActionGroup";
import { formattedPrice } from "../../helpers/currency";

function OfferProductTable({
  products,
  onDelete,
  onEdit,
  onArchive,
  currency,
}) {
  const columns = [
    {
      key: "product",
      label: "Product",
      render: (product) => (
        <MediaCell
          src={product.imageUrl}
          alt={product.name}
          title={product.name}
        />
      ),
    },
    {
      key: "validUntil",
      label: "Valid Until",
      width: "160px",
      render: (product) => formatAppDate(product.validUntil),
    },
    {
      key: "offerPrice",
      label: "Offer Price",
      width: "160px",
      render: (product) => (
        <span>
          <span className="mr-2 text-slate-400 line-through">
            {product.price}
          </span>
          <span className="font-semibold">
            {formattedPrice(currency, product.offerPrice)}
          </span>
        </span>
      ),
    },
    {
      key: "status",
      label: "Status",
      width: "160px",
      render: (product) => <StatusBadge active={product.active} />,
    },
    {
      key: "actions",
      label: "Actions",
      align: "right",
      width: "140px",
      render: (product) => (
        <ActionGroup>
          <ActionButton
            color={!product.active ? "green" : "orange"}
            onClick={() => onArchive(product)}
            title={!product.active ? "Activate" : "Archive"}
          >
            {!product.active ? <ActivateIcon /> : <ArchiveIcon />}
          </ActionButton>
          <ActionButton
            color="blue"
            onClick={() => onEdit(product)}
            title="Edit"
          >
            <EditIcon />
          </ActionButton>
          <ActionButton
            color="red"
            onClick={() => onDelete(product)}
            title="Delete"
          >
            <DeleteIcon />
          </ActionButton>
        </ActionGroup>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={products}
      rowKey="id"
      minWidth="760px"
      emptyMessage="No products found."
    />
  );
}

export default OfferProductTable;
